__turbopack_context__.v({
  "className": "quicksand_e77b118-module__WbaVuW__className",
  "variable": "quicksand_e77b118-module__WbaVuW__variable",
});
